import { Socket, LongPoll } from 'phoenix'

export function getConfig() {
  return document.body.dataset
}

export function getEndpoint(path) {
  const parser = document.createElement('a')
  let { socketUrl, botId } = getConfig()
  if (!botId) {
    botId = JSON.parse(getConfig().bot).id
  }

  parser.href = socketUrl
  return `${parser.protocol.replace(/^ws/, 'http')}//${parser.host}/api/bot/${botId}` + (path ? '/' + path : '')
}

let socket = null
let connected = null

export function getExternalSocket(connectedCallback) {
  if (socket === null) {
    const heartbeatIntervalMs = 5000
    socket = new Socket(getConfig().socketUrl, { params: {}, reconnectAfterMs: () => 1000, heartbeatIntervalMs })
    socket.connect()

    socket.onOpen(() => {
      connected = true
    })

    socket.onError(() => {
      socket.channels.forEach(ch => {
        const params = ch.params()
        ch.params = () => ({ ...params, reconnect: true })
        ch.joinPush.payload = ch.params
      })

      if (connected === null) {
        // close the socket with an error code
        socket.disconnect(null, 3000)
        // fall back to long poll
        socket.transport = LongPoll
        // reopen
        socket.connect()
      }
    })

    socket.onClose(() => {
      connected = false
    })
  }
  if (typeof connectedCallback === 'function') {
    socket.onOpen(() => connectedCallback(true))
    socket.onClose(() => connectedCallback(false))
    setTimeout(() => connectedCallback(connected), 0)
  }
  return socket
}
